import { CreateRequestModal } from './CreateRequestModal/CreateRequestModal';
import withFlaggedTransactions from './withFlaggedTransactions';
import withQueue from './withQueue';

export { CreateModal } from './CreateModal';
export { CreateRequestModal } from './CreateRequestModal/CreateRequestModal';
export { CreateRequestEmailModal } from './CreateRequestEmailModal/CreateRequestEmailModal';
export { CreateGroupModal } from './CreateGroupModal';

export const FlaggedTransactionCreateAskReq = withFlaggedTransactions(CreateRequestModal);
export const QueueCreateAskReq = withQueue(CreateRequestModal);
